import React, {useContext, useEffect, useRef, useState} from 'react';
import {ClientWidthContext} from '../Context/ApplicationContextProvider';
import Icon from '../Icon/Icon';
// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
//import './PromoBanners.css';

// import required modules
import {Pagination, Navigation, Keyboard, Autoplay} from 'swiper/modules';
import {eventEmitter} from "../../common/baseData";

function PromoBanners(props) {

  const {items} = props;

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const progressBarRef = useRef(null);

  return (
    <>
      {Array.isArray(items) && items.length > 0 && (
        <div className={`relative flex items-center w-full h-[540px]`}
             onClick={event => {
               event.stopPropagation();
             }}>
          <button type="button" ref={prevRef}
                  className="prev-btn-promo border-0 left-[10px] w-8 h-8 transition-all duration-100 rounded-full border border-[#D9D9D9] bg-white text-[0] leading-[0] absolute top-1/2 right-auto transform -translate-y-1/2 block p-0 cursor-pointer text-transparent outline-none z-[4]"
                  style={{transform: 'translate(50% - 20px, 0)'}}>
            {/*<Icon name={'slider-left-arrow'} className="h-[23px] w-[32px]"/>*/}
          </button>
          <button type="button" ref={nextRef}
                  className="next-btn-promo border-0 w-8 h-8 transition-all duration-100 rounded-full border border-[#D9D9D9] bg-white text-[0] leading-[0] absolute top-1/2 right-[10px] transform -translate-y-1/2 block p-0 cursor-pointer text-transparent outline-none z-[4]"
                  style={{transform: 'translate(50% - 20px, 0)'}}>
            {/*<Icon name={'slider-left-arrow'} className="h-[23px] w-[32px] rotate-180"/>*/}
          </button>
          <Swiper
            modules={[Pagination, Navigation, Keyboard, Autoplay]}
            loop={true}
            pagination={{
              type: 'progressbar',
              el: progressBarRef.current,
              progressbarFillClass: `absolute left-0 top-0 bg-blue-primary w-full h-full origin-top-left`,
            }}
            navigation={{
              prevEl: prevRef.current,
              nextEl: nextRef.current,
            }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            spaceBetween={8}
            threshold={10}
            allowTouchMove={true}
            slidesPerView={'auto'}
            keyboard={{enabled: true}}
            className={`h-full`}>
            {items.map((banner, index) => (
              <SwiperSlide
                key={`promo-banner-desktop-${index}`}
                className="!w-[290px] 1440:!w-[320px] min-[1660px]:!w-[calc((100%-24px)/4)]">
                <a href={banner.link} {...(banner.attribute_rel && { rel: banner.attribute_rel })}
                   className={`block h-full rounded-[14px] overflow-hidden`}
                   onClick={() => {eventEmitter.emit('showLoader')}}>
                  <picture>
                    <source srcSet={banner.picture.avif} type="image/avif"/>
                    <source srcSet={banner.picture.webp} type="image/webp"/>
                    <img src={banner.picture.orig}
                         className='h-full w-full object-cover'
                         loading={index === 0 ? 'eager' : 'lazy'}
                         decoding="async"
                         fetchpriority={index === 0 ? 'high' : 'low'}
                         width={banner.picture?.width}
                         height={banner.picture?.height}
                         style={{
                           height: '100%',
                           objectFit: 'cover',
                         }}/>
                  </picture>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
          <div id="promo-banners-desktop-pagination" ref={progressBarRef}
               className={`absolute bottom-[-11px] w-full h-1 !bg-grey-10 z-10`}/>
        </div>
      )}
    </>
  );
}

export default PromoBanners;